import type { EntityNoticeEntryProps } from './entity-notice-entry.types'
import { EntityNoticeEntryEmailFirst } from './entity-notice-entry-email-first'
import { EntityNoticeEntryPicker } from './entity-notice-entry-picker'

export type { EntityNoticeEntryProps }

/**
 * Dispatches by shape, not by scattered `if`s inside one component: cells A
 * and C share `EntityNoticeEntryEmailFirst` (they differ only by copy,
 * resolved through `resolveEntityNoticeCopy`), cell B has its own picker
 * shape entirely (diff line 6 — Invariante 3 rewritten).
 */
export function EntityNoticeEntry(props: EntityNoticeEntryProps) {
  if (props.variant === 'variantB') {
    const { variant: _variant, ...pickerProps } = props
    return <EntityNoticeEntryPicker {...pickerProps} />
  }

  return <EntityNoticeEntryEmailFirst {...props} variant={props.variant} />
}
